module.exports = __webpack_public_path__ + "img/remove-watchlist.991d3a3e.svg";